import React, { useState, useContext } from "react";
import styled from "styled-components";
import { db, storage } from "../firebase/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { UserContext } from "../context/UserContext";

const CreateMySkillsPage = () => {
  const { user } = useContext(UserContext);

  const [pageName, setPageName] = useState("");
  const [coverPhoto, setCoverPhoto] = useState(null);
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCreatePage = async () => {
    if (!pageName || !coverPhoto || !logo || !user?.id) return;
    setLoading(true);

    try {
      // Upload cover photo
      const coverRef = ref(
        storage,
        `myskills-pages/${user.id}/cover_${Date.now()}`
      );
      await uploadBytes(coverRef, coverPhoto);
      const coverUrl = await getDownloadURL(coverRef);

      // Upload logo
      const logoRef = ref(
        storage,
        `myskills-pages/${user.id}/logo_${Date.now()}`
      );
      await uploadBytes(logoRef, logo);
      const logoUrl = await getDownloadURL(logoRef);

      // Save page info in Firestore
      await addDoc(collection(db, "myskillsPages"), {
        userId: user.id,
        pageName,
        coverUrl,
        logoUrl,
        createdAt: serverTimestamp(),
        createdByName: user.name,
      });

      // Reset form
      setPageName("");
      setCoverPhoto(null);
      setLogo(null);
      alert("MySkills Page Created Successfully!");
    } catch (err) {
      console.error("Error creating page:", err);
      alert("Failed to create page. Try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper>
      <Title>Create MySkills Page</Title>

      <Form>
        <input
          type="text"
          placeholder="Page Name"
          value={pageName}
          onChange={(e) => setPageName(e.target.value)}
        />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setCoverPhoto(e.target.files[0])}
        />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setLogo(e.target.files[0])}
        />
        <button onClick={handleCreatePage} disabled={loading}>
          {loading ? "Creating..." : "Create Page"}
        </button>
      </Form>
    </PageWrapper>
  );
};

export default CreateMySkillsPage;

/* ---------------- Styled Components ---------------- */

const PageWrapper = styled.div`
  padding: 20px;
  background: #121212;
  min-height: 100vh;
  color: #fff;
`;

const Title = styled.h2`
  color: #a855f7;
  text-align: center;
  margin-bottom: 20px;
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 500px;
  margin: auto;

  input {
    padding: 12px;
    border-radius: 8px;
    border: none;
  }

  button {
    padding: 12px;
    border-radius: 8px;
    border: none;
    background: #a855f7;
    color: #fff;
    font-weight: bold;
    cursor: pointer;
    transition: 0.2s ease;

    &:hover {
      background: #9333ea;
    }

    &:disabled {
      background: #555;
      cursor: not-allowed;
    }
  }
`;
